import React from 'react'

import styles from './styles.module.css'

const SingleColumnPage: React.FC = ({children}) => {
  return (
    <div className={styles.page}>
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default SingleColumnPage
